import {configureStore} from '@reduxjs/toolkit'
import userSelectorReducer from './features/userSelector'


export default configureStore({
    reducer: {
        userSelector: userSelectorReducer,

    },
})